<template>
  <BaseModal v-model="isOpen" @update:modelValue="handleModelUpdate">
    <template #title>
      <div class="text-center">Add Additional Information</div>
    </template>
    <div class="space-y-4">
      <div>
        <textarea
          id="metaPrompt"
          v-model="localMetaPrompt"
          rows="4"
          class="mt-1 block w-full rounded-lg border border-gray-700 bg-dark px-3 py-2 text-sm text-gray-100 placeholder-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          placeholder="Enter additional information about this product..."
        />
      </div>
    </div>
    <template #footer>
      <div class="flex justify-end gap-3">
        <button
          type="button"
          class="rounded-lg border border-gray-700 px-4 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700/50"
          @click="handleClose"
        >
          Cancel
        </button>
        <button
          type="button"
          class="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary-dark"
          @click="handleSave"
        >
          Save
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import BaseModal from '@/components/ui/BaseModal.vue'

const props = defineProps<{
  show: boolean
  metaPrompt?: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'save', value: string): void
}>()

const isOpen = ref(props.show)
const localMetaPrompt = ref(props.metaPrompt || '')

watch(() => props.show, (newShow) => {
  isOpen.value = newShow
  if (newShow) {
    localMetaPrompt.value = props.metaPrompt || ''
  }
})

const handleModelUpdate = (value: boolean) => {
  if (!value) {
    handleClose()
  }
}

const handleClose = () => {
  isOpen.value = false
  emit('close')
}

const handleSave = () => {
  emit('save', localMetaPrompt.value)
}
</script>
